import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockOpen16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLockOpen16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.06 2.588c-.337.087-.632.24-.805.483a5 5 0 0 0-.285.433.5.5 0 0 1-.966-.23l.496.06c-.497-.06-.496-.06-.496-.061v-.006l.001-.007.002-.013a.5.5 0 0 1 .04-.128q.023-.056.065-.13a6 6 0 0 1 .327-.496c.368-.519.927-.759 1.37-.873.451-.116.853-.122.996-.12h.034l.047.001A3.114 3.114 0 0 1 11 4.616V5.8h1a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7.8a2 2 0 0 1 2-2h6V4.616A2.114 2.114 0 0 0 7.81 2.5h-.02c-.098-.002-.4.002-.73.087M12 6.8H4a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7.8a1 1 0 0 0-1-1m-4 4.7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockOpen16);
